/**
 * Exports JSON data to a downloadable CSV file
 * @param data - Array of objects to convert to CSV
 * @param filename - File name for downloaded CSV
 */
export const exportToCSV = async (
  data: object[],
  filename = "data.csv"
): Promise<void> => {
  if (!data || data.length === 0) {
    console.warn("No data available to export.");
    return;
  }

  try {
    // Get headers from the first object's keys
    const headers = Object.keys(data[0]);

    // Convert data to CSV format
    const csvContent = [
      headers.join(","), // Header row
      ...data.map((row) =>
        headers
          .map((header) => {
            const value = row[header as keyof typeof row];
            // Handle values that might contain commas or quotes
            const stringValue = String(value ?? "");
            if (
              stringValue.includes(",") ||
              stringValue.includes('"') ||
              stringValue.includes("\n")
            ) {
              return `"${stringValue.replace(/"/g, '""')}"`;
            }
            return stringValue;
          })
          .join(",")
      ),
    ].join("\n");

    // Create blob and download
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Clean up
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error exporting CSV:", error);
    throw error;
  }
};
